/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _scripts_components_Note_Note__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./scripts/components/Note/Note */ "./resources/scripts/components/Note/Note.ts");
/* harmony import */ var _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* harmony import */ var _scripts_components_RangeSlider_RangeSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/RangeSlider/RangeSlider */ "./resources/scripts/components/RangeSlider/RangeSlider.ts");
/* harmony import */ var _scripts_components_Quiz_Quiz__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/Quiz/Quiz */ "./resources/scripts/components/Quiz/Quiz.ts");




customElements.define('note-component', _scripts_components_Note_Note__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define('geolocator-component', _scripts_components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define('range-slider', _scripts_components_RangeSlider_RangeSlider__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define('quiz-component', _scripts_components_Quiz_Quiz__WEBPACK_IMPORTED_MODULE_3__["default"]);

/***/ }),

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts":
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");

// Geolocator - haandskrevet erstatning af den kompilerede version (okt. 2026).
// Aendringer i forhold til originalen:
//  - "Hvor er den besoegende nu" afgoeres ud fra aktivt land (Shopify.country) for Market-blokke
//    og ud fra domaenet for Country-blokke - ikke ud fra sproget (Shopify.locale).
//  - Besoegende fra et land uden egen blok faar kun den primaere popup, hvis de staar paa et
//    andet lands side. Er de allerede i fallback-markedet (fx International), vises intet.
//  - Klik paa "Ja"-knappen saetter en cookie, saa popuppen ikke kommer igen ved naeste sidevisning.
//  - Manglende primaer blok, manglende locale-match eller fejl i landeopslag giver ikke laengere JS-fejl.

var cookies = _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__;
var STAY_COOKIE_MINUTES = 10;
var REDIRECT_COOKIE_MINUTES = 60 * 24;

function normalizeCode(code) {
  return (code || '').toString().trim().toUpperCase();
}

function stripWww(hostname) {
  return (hostname || '').toLowerCase().replace(/^www\./, '');
}

class Geolocator extends HTMLElement {
  constructor() {
    super();
    this.countryData = window.countryData || [];
    this.url = window.location.href;
    this.swithcButtons = Array.from(document.querySelectorAll('.switch-button'));
    this.geoPopupTriggers = Array.from(document.querySelectorAll('.geolocator-trigger'));
    this.visitorCountryCode = null;
  }

  async connectedCallback() {
    this.checkUrlForParam();

    this.swithcButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.handleSwitchButtonClick(button);
      });
    });

    const { countryData } = this;
    if (!countryData.length) return;

    const primaryCountry = countryData.find((country) => country.primaryCountry === true);

    let visitorCountry = null;
    try {
      visitorCountry = await this.getVisitorCountry();
    } catch (error) {
      console.warn('Geolocator: kunne ikke finde den besoegendes land', error);
    }
    this.visitorCountryCode = visitorCountry ? normalizeCode(visitorCountry.handle) : null;

    const visitorBlock = this.findBlockByCountryCode(this.visitorCountryCode);

    const triggerCountry = visitorBlock || primaryCountry || countryData[0];
    this.geoPopupTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.showGeoPopup(triggerCountry);
      });
    });

    const editionGeoCookie = cookies.getCookie('edition-geocookie');
    const editionGeoSwitchCookie = cookies.getCookie('edition-geoswitch');
    if (editionGeoCookie || editionGeoSwitchCookie || (window.Shopify && Shopify.designMode === true)) return;
    if (!this.visitorCountryCode) return;

    const popupCountry = this.getPopupCountry(visitorBlock, primaryCountry);
    if (popupCountry) this.showGeoPopup(popupCountry);
  }

  // Returnerer den blok popuppen skal vise, eller null hvis den besoegende allerede er det rigtige sted
  getPopupCountry(visitorBlock, primaryCountry) {
    if (visitorBlock) {
      return this.isOnCountry(visitorBlock) ? null : visitorBlock;
    }

    // Land uden egen blok: vis kun den primaere popup hvis de staar paa et andet lands side
    if (!primaryCountry || this.isOnCountry(primaryCountry)) return null;
    const isOnOtherCountry = this.countryData.some((country) => country !== primaryCountry && this.isOnCountry(country));
    return isOnOtherCountry ? primaryCountry : null;
  }

  // Market-blokke: aktivt land i Shopify. Country-blokke: samme domaene som linket.
  isOnCountry(country) {
    const shopify = window.Shopify || {};

    if (country.type === 'Market') {
      if (shopify.country) return normalizeCode(shopify.country) === normalizeCode(country.countryCode);
      return !!country.locale && country.locale === shopify.locale;
    }

    if (country.link) {
      try {
        const linkHost = new URL(country.link, window.location.origin).hostname;
        return stripWww(linkHost) === stripWww(window.location.hostname);
      } catch (error) {
        return false;
      }
    }

    return !!country.locale && country.locale === shopify.locale;
  }

  findBlockByCountryCode(code) {
    if (!code) return undefined;
    return this.countryData.find((country) => normalizeCode(country.countryCode) === code);
  }

  // Den primaere blok har ofte en kode som "EU", som Shopify ikke kender.
  // For besoegende fra et land uden egen blok sendes deres eget land i stedet.
  getLocalizationCountryCode(countryCode) {
    const code = normalizeCode(countryCode);
    const visitorHasOwnBlock = !!this.findBlockByCountryCode(this.visitorCountryCode);
    const block = this.findBlockByCountryCode(code);
    if (block && block.primaryCountry && this.visitorCountryCode && !visitorHasOwnBlock) {
      return this.visitorCountryCode;
    }
    return code;
  }

  async getVisitorCountry() {
    const response = await fetch('/browsing_context_suggestions.json');
    const data = await response.json();
    const visitorCountry = data.detected_values.country;
    this.setAttribute('data-visitor-country', visitorCountry.handle);
    return visitorCountry;
  }

  showGeoPopup(countryObject) {
    if (!countryObject) return;

    this.classList.remove('tw-z-[-1]');
    this.classList.add('tw-z-[10000]');
    setTimeout(() => {
      this.classList.add('!tw-opacity-100');
    }, 500);

    const { layout } = this.dataset;
    const heading = this.querySelector('#geolocator-heading');
    const buttonStay = this.querySelector('#geolocator-button-stay');

    if (layout === 'primary') {
      const img = this.querySelector('#geolocator-flag');
      const richtext = this.querySelector('#geolocator-richtext');
      const buttonRedirect = this.querySelector('#geolocator-button-redirect');
      if (img) {
        img.src = countryObject.flag;
      }
      if (heading) heading.innerHTML = countryObject.heading;
      if (richtext) richtext.innerText = countryObject.richtext;
      if (buttonRedirect) {
        buttonRedirect.innerHTML = countryObject.button_one;
        // onclick i stedet for addEventListener, saa gentagne aabninger ikke stabler handlers
        buttonRedirect.onclick = () => this.handleClickedRedirectButton(countryObject);
      }
    } else {
      this.SortAndOrderCountries(countryObject);
      if (heading) heading.innerHTML = countryObject.heading;
    }

    if (buttonStay) {
      buttonStay.innerHTML = countryObject.button_two;
      buttonStay.onclick = () => this.handleClickedStayButton();
    }
  }

  handleClickedStayButton() {
    this.classList.remove('!tw-opacity-100');
    this.classList.add('tw-opacity-0');
    cookies.setCookie('edition-geocookie', 'true', STAY_COOKIE_MINUTES);
    setTimeout(() => {
      this.remove();
    }, 1000);
  }

  handleClickedRedirectButton(countryObject) {
    cookies.setCookie('edition-geocookie', 'true', REDIRECT_COOKIE_MINUTES);
    this.remove();

    if (countryObject.type === 'Market') {
      this.updateLocalization(this.getLocalizationCountryCode(countryObject.countryCode), countryObject.locale);
    } else if (countryObject.link) {
      window.location.href = this.withGeoSwitchParam(countryObject.link);
    }
  }

  // Cookies foelger ikke med til et andet domaene, saa modtagersiden saetter sin egen via URL-parameteren
  withGeoSwitchParam(link) {
    try {
      const url = new URL(link, window.location.origin);
      url.searchParams.set('edition-geoswitch', '');
      return url.toString();
    } catch (error) {
      return link;
    }
  }

  checkUrlForParam() {
    if (this.url.includes('edition-geoswitch')) {
      cookies.setCookie('edition-geoswitch', 'true', STAY_COOKIE_MINUTES);
    }
  }

  SortAndOrderCountries(countryObject) {
    const currentCountryListHolder = this.querySelector('#geolocator-country-list');
    if (!currentCountryListHolder) return;
    const currentCountryList = Array.from(currentCountryListHolder.querySelectorAll('.geolocator_country'));
    // Laeg landene med samme locale som countryObject oeverst i listen
    currentCountryList.sort((a, b) => {
      if (a.dataset.locale === countryObject.locale) return -1;
      if (b.dataset.locale === countryObject.locale) return 1;
      return 0;
    });
    currentCountryList.forEach((country) => {
      currentCountryListHolder.appendChild(country);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  updateLocalization(countryCode, countryLocale) {
    const form = document.createElement('form');
    form.action = '/localization';
    form.method = 'POST';
    form.hidden = true;
    [['_method', 'PUT'], ['country_code', countryCode], ['language_code', countryLocale]].forEach(([name, value]) => {
      const input = document.createElement('input');
      input.name = name;
      input.value = value || '';
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  handleSwitchButtonClick(button) {
    const { type, handle, locale } = button.dataset;
    if (type === 'Market') {
      cookies.setCookie('edition-geocookie', 'true', REDIRECT_COOKIE_MINUTES);
      this.updateLocalization(this.getLocalizationCountryCode(handle), locale);
    } else {
      window.location.href = button.href;
    }
  }

  handleGeoPopupTriggerClick(countryData) {
    this.showGeoPopup(countryData);
  }
}


/***/ }),

/***/ "./resources/scripts/components/Note/Note.ts":
/*!***************************************************!*\
  !*** ./resources/scripts/components/Note/Note.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ NoteComponent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var NoteComponent = /*#__PURE__*/function (_HTMLElement) {
  function NoteComponent() {
    var _this;
    _classCallCheck(this, NoteComponent);
    _this = _callSuper(this, NoteComponent);
    var noteTriggers = Array.from(document.querySelectorAll('.edition_note_trigger'));
    var noteContent = document.getElementById('edition_note');
    if (noteContent) {
      noteTriggers.forEach(function (noteTrigger) {
        noteTrigger.addEventListener('click', function () {
          noteContent.classList.toggle('edition_note_visible');
        });
      });
    }
    return _this;
  }
  _inherits(NoteComponent, _HTMLElement);
  return _createClass(NoteComponent);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/Quiz/Quiz.ts":
/*!***************************************************!*\
  !*** ./resources/scripts/components/Quiz/Quiz.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ QuizComponent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var QuizComponent = /*#__PURE__*/function (_HTMLElement) {
  function QuizComponent() {
    var _this;
    _classCallCheck(this, QuizComponent);
    _this = _callSuper(this, QuizComponent);
    _defineProperty(_this, "nextButton", _this.querySelector('button[data-action="next"]'));
    _defineProperty(_this, "prevButton", _this.querySelector('button[data-action="prev"]'));
    _defineProperty(_this, "restartButton", _this.querySelector('button[data-action="restart"]'));
    _defineProperty(_this, "questionsWrapper", _this.querySelector('#questions-wrapper'));
    _defineProperty(_this, "questions", Array.from(_this.questionsWrapper.querySelectorAll('div[data-step]')));
    _defineProperty(_this, "progressBar", _this.querySelector('#progress-bar'));
    _defineProperty(_this, "currentQuestion", 0);
    _defineProperty(_this, "quizAvailableProducts", window.quizAvailableProducts || []);
    _defineProperty(_this, "emailInputFiled", _this.querySelector('input[type="email"]'));
    _defineProperty(_this, "yearButtons", Array.from(_this.querySelectorAll('.year-button')));
    _defineProperty(_this, "showResults", true);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    return _this;
  }
  _inherits(QuizComponent, _HTMLElement);
  return _createClass(QuizComponent, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setTimeout(function () {
                _this2.getAllProductsData(2);
              }, 5000);
              this.nextButton.addEventListener('click', function (event) {
                event.preventDefault();
                _this2.handleNext();
                // scroll to the top of the page
                window.scrollTo(0, 0);
              });
              this.prevButton.addEventListener('click', function (event) {
                event.preventDefault();
                _this2.handlePrev();
                // scroll to the top of the page
                window.scrollTo(0, 0);
              });
              this.restartButton.addEventListener('click', function (event) {
                event.preventDefault();
                _this2.handleRestart();
              });
              this.addEventListeners();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "handleNext",
    value: function handleNext() {
      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion += 1;
        this.updateButtonsState(this.nextButton, this.currentQuestion !== this.questions.length - 1, this.prevButton, false);
        this.updateProgressBar();
        this.updateQuestions();
      } else {
        this.handleQuizSubmit();
      }
    }
  }, {
    key: "handlePrev",
    value: function handlePrev() {
      if (this.currentQuestion > 0) {
        this.currentQuestion -= 1;
        this.updateButtonsState(this.nextButton, false, this.prevButton, this.currentQuestion === 0);
        this.updateProgressBar();
        this.updateQuestions();
      }
    }
  }, {
    key: "updateProgressBar",
    value: function updateProgressBar() {
      var progress = this.currentQuestion / this.questions.length * 100;
      this.progressBar.style.background = "linear-gradient(to right, black ".concat(progress, "%, #E5E7EB ").concat(progress, "%)");
    }
  }, {
    key: "updateQuestions",
    value: function updateQuestions() {
      var _this3 = this;
      this.questions.forEach(function (question, index) {
        if (index === _this3.currentQuestion) {
          question.style.display = 'flex';
        } else {
          question.style.display = 'none';
        }
      });
      var currentQuestion = this.questions[this.currentQuestion];
      if (currentQuestion.dataset.results) {
        if (this.showResults === true) {
          this.displayResults();
          this.showResults = false;
        } else {
          this.addEventListenerToRecommendations();
        }
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "updateButtonsState",
    value: function updateButtonsState(nextButton, nextButtonState, prevButton, prevButtonState) {
      nextButton.disabled = nextButtonState;
      prevButton.disabled = prevButtonState;
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this4 = this;
      document.addEventListener('range-slider-change', function (event) {
        _this4.nextButton.disabled = false;
      });
      this.emailInputFiled.addEventListener('input', function (event) {
        _this4.nextButton.disabled = !_this4.emailInputFiled.validity.valid;
      });
      this.yearButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          _this4.handleToggleYearSelection(button);
        });
      });
    }
  }, {
    key: "handleToggleYearSelection",
    value: function handleToggleYearSelection(button) {
      var _this5 = this;
      var year = button.dataset.year;
      var yearSelectionModalOverlay = this.querySelector(".year-selection-modal-overlay[data-year=\"".concat(year, "\"]"));
      var yearSelectionModal = yearSelectionModalOverlay.querySelector('.year-selection-modal');
      // if the display is flex, hide the modal
      yearSelectionModalOverlay.style.display = yearSelectionModalOverlay.style.display === 'flex' ? 'none' : 'flex';
      setTimeout(function () {
        yearSelectionModal.style.opacity = yearSelectionModalOverlay.style.display === 'flex' ? '1' : '0';
      }, 100);
      if (yearSelectionModalOverlay.getAttribute('data-eventlistenersadded') === 'true') {
        return;
      }
      var closeButton = yearSelectionModalOverlay.querySelector('.year-selection-modal-close');
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this5.handleToggleYearSelection(button);
      });
      var yearSelectionButtons = Array.from(yearSelectionModalOverlay.querySelectorAll('.year-selection-button'));
      yearSelectionButtons.forEach(function (yearSelectionButton) {
        yearSelectionButton.addEventListener('click', function (event) {
          event.preventDefault();
          _this5.showResults = true;
          var productsForYear = _this5.quizAvailableProducts.filter(function (product) {
            return product.year === button.dataset.year;
          });
          if (productsForYear.length > 1) {
            var prices = productsForYear.map(function (product) {
              return product.price;
            });
            var _ref = [Math.min.apply(Math, _toConsumableArray(prices)), Math.max.apply(Math, _toConsumableArray(prices))],
              minPrice = _ref[0],
              maxPrice = _ref[1];
            // const priceRangeSlider = this.querySelector('range-slider');
            // priceRangeSlider.setAttribute('min', minPrice.toString());
            // priceRangeSlider.setAttribute('max', maxPrice.toString());
            // priceRangeSlider.setAttribute('value', minPrice.toString());
          } else {
            // set default values
            // const priceRangeSlider = this.querySelector('range-slider');
            // priceRangeSlider.setAttribute('min', priceRangeSlider.getAttribute('data-defaultmin'));
            // priceRangeSlider.setAttribute('max', priceRangeSlider.getAttribute('data-defaultmax'));
            // priceRangeSlider.setAttribute('value', priceRangeSlider.getAttribute('data-defaultmin'));
          }
          localStorage.setItem('selectedYear', yearSelectionButton.dataset.year);
          _this5.handleToggleYearSelection(button);
          _this5.handleNext();
        });
      });
      yearSelectionModalOverlay.setAttribute('data-eventlistenersadded', 'true');
    }
  }, {
    key: "displayResults",
    value: function displayResults() {
      var text = window.quizTranslations.results;
      var recommendationsWrapper = this.querySelector('#recommendations');
      recommendationsWrapper.innerHTML = '';
      // generate results
      var selectedYear = localStorage.getItem('selectedYear');
      var selectedPriceRange = this.querySelector('range-slider');
      var handles = Array.from(selectedPriceRange.querySelectorAll('.handle'));
      var selectedPriceRangeValuesArray = handles.map(function (handle) {
        return Number(handle.dataset.value);
      });
      var selectedPriceRangeMin = selectedPriceRangeValuesArray[0];
      var selectedPriceRangeMax = selectedPriceRangeValuesArray[1];
      var productsThatMatchPriceAndYear = this.quizAvailableProducts.filter(function (product) {
        var productYear = product.year;
        var productPrice = product.price;
        return productYear === selectedYear && productPrice >= selectedPriceRangeMin && productPrice <= selectedPriceRangeMax;
      });
      var productsThatMatchYear = this.quizAvailableProducts.filter(function (product) {
        var productYear = product.year;
        return productYear === selectedYear;
      });
      var productsThatMatchPrice = this.quizAvailableProducts.filter(function (product) {
        var productPrice = product.price;
        return productPrice >= selectedPriceRangeMin && productPrice <= selectedPriceRangeMax;
      });
      var getRandomProducts = function getRandomProducts(products, count) {
        var randomProducts = [];
        var availableProducts = _toConsumableArray(products);
        var limit = Math.min(count, availableProducts.length);
        for (var i = 0; i < limit; i += 1) {
          var randomIndex = Math.floor(Math.random() * availableProducts.length);
          randomProducts.push(availableProducts[randomIndex]);
          availableProducts.splice(randomIndex, 1);
        }
        return randomProducts;
      };
      var displayProductHtml = function displayProductHtml(products) {
        products.forEach(function (product) {
          var productElement = document.createElement('a');
          productElement.href = "#";
          productElement.classList.add('tw-flex', 'tw-flex-col', 'tw-gap-2', 'tw-bg-white', 'product-rec');
          productElement.dataset.id = product.variantid;
          productElement.innerHTML = "\n          <img src=\"".concat(product.image, "\" alt=\"\" class=\"tw-w-full tw-h-[150px] md:tw-h-[200px] tw-object-cover\">\n          <h4 class=\"tw-font-bold tw-text-[14px] md:tw-text-[16px] tw-m-0\" style=\"word-break: break-word;\">\n            ").concat(product.title, "\n          </h4>\n          <p class=\"tw-text-[12px] md:tw-text-[14px] tw-m-0\">\n            ").concat(product.price, " ").concat(Shopify.currency.active, "\n          </p>\n        ");
          recommendationsWrapper.appendChild(productElement);
        });
      };
      // if products are found for the selected year and price range, display 4 random products
      if (productsThatMatchPriceAndYear.length > 0) {
        var randomProducts = getRandomProducts(productsThatMatchPriceAndYear, 4);
        displayProductHtml(randomProducts);
      } else if (productsThatMatchPriceAndYear.length === 0) {
        // if no products are found for the selected year and price range, display 8 random products for the selected year
        if (productsThatMatchYear.length > 0) {
          text = window.quizTranslations.reasons.noProductsFoundForSelectedPriceRange;
          var _randomProducts = getRandomProducts(productsThatMatchYear, 8);
          displayProductHtml(_randomProducts);
        } else if (productsThatMatchYear.length === 0) {
          // if no products are found for the selected year, display 8 random products for the selected price range
          text = window.quizTranslations.reasons.noProductsFoundForSelectedYear;
          var _randomProducts2 = getRandomProducts(productsThatMatchPrice, 8);
          displayProductHtml(_randomProducts2);
        }
      }
      var textElement = document.getElementById('results-title');
      textElement.innerHTML = text;
      this.addEventListenerToRecommendations();
      // add event listeners to the products
    }
  }, {
    key: "addEventListenerToRecommendations",
    value: function addEventListenerToRecommendations() {
      var _this6 = this;
      var productElements = Array.from(this.querySelectorAll('.product-rec'));
      productElements.forEach(function (productElement) {
        var eventListenerHasBeenAdded = productElement.dataset.eventlisteneradded;
        if (eventListenerHasBeenAdded !== 'true') {
          productElement.dataset.eventlisteneradded = 'true';
          productElement.addEventListener('click', function (event) {
            event.preventDefault();
            var closestStepWrapper = productElement.closest('div[data-step]');
            var productsInWrapper = Array.from(closestStepWrapper.querySelectorAll('.product-rec'));
            var allowMultiselect = closestStepWrapper.dataset.allowmultiselect;
            // if the current step has data-allowmultiselect
            if (allowMultiselect === 'true') {
              // if the product is already selected, deselect it
              if (productElement.classList.contains('selected')) {
                productElement.classList.remove('selected');
                return;
              }
              // if the product is not selected, select it
              productElement.classList.add('selected');
            } else {
              // if the current step does not have data-allowmultiselect
              // deselect all other products in the wrapper
              productsInWrapper.forEach(function (productInWrapper) {
                productInWrapper.classList.remove('selected');
              });
              // select the clicked product
              productElement.classList.add('selected');
            }
            // enable the next button
            _this6.nextButton.disabled = false;
          });
        }
      });
    }
  }, {
    key: "getAllProductsData",
    value: function () {
      var _getAllProductsData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(page) {
        var nextPageUrl, response, text, parser, doc, scriptTags, newProducts, _this$quizAvailablePr;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              nextPageUrl = "".concat(window.location.pathname, "?page=").concat(page);
              _context2.prev = 1;
              _context2.next = 4;
              return fetch(nextPageUrl);
            case 4:
              response = _context2.sent;
              _context2.next = 7;
              return response.text();
            case 7:
              text = _context2.sent;
              // Create a temporary DOM element to parse the response
              parser = new DOMParser();
              doc = parser.parseFromString(text, 'text/html'); // Look for script tags containing our product data
              scriptTags = doc.querySelectorAll('script');
              newProducts = [];
              scriptTags.forEach(function (script) {
                if (script.innerText.includes('window.quizAvailableProducts.push')) {
                  try {
                    // Safer approach: Use Function constructor to evaluate JavaScript expressions
                    // This avoids issues with regex-based parsing of complex objects
                    var scriptContent = script.innerText;
                    // Extract each push statement and evaluate them
                    var pushRegex = /window\.quizAvailableProducts\.push\(([\s\S]*?)\);/g;
                    var match;
                    while ((match = pushRegex.exec(scriptContent)) !== null) {
                      if (match[1]) {
                        try {
                          // Use Function constructor as a safer eval alternative
                          // This will parse the object literal and return the actual object
                          var objFunction = new Function("return ".concat(match[1]));
                          var product = objFunction();
                          if (product && _typeof(product) === 'object') {
                            newProducts.push(product);
                          }
                        } catch (objError) {
                          console.error('Error evaluating product object:', objError);
                        }
                      }
                    }
                  } catch (parseError) {
                    console.error('Error processing script content:', parseError);
                  }
                }
              });
              if (newProducts.length > 0) {
                (_this$quizAvailablePr = this.quizAvailableProducts).push.apply(_this$quizAvailablePr, newProducts);
                this.getAllProductsData(page + 1);
              }
              _context2.next = 19;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](1);
              console.error('Error fetching page:', _context2.t0);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 16]]);
      }));
      function getAllProductsData(_x) {
        return _getAllProductsData.apply(this, arguments);
      }
      return getAllProductsData;
    }()
  }, {
    key: "handleQuizSubmit",
    value: function () {
      var _handleQuizSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var email, selectedProducts, selectedProductIds, goToCheckoutButton;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              email = this.emailInputFiled.value;
              _context3.next = 4;
              return this.updateCustomerTags(email);
            case 4:
              selectedProducts = Array.from(this.querySelectorAll('.product-rec.selected'));
              selectedProductIds = selectedProducts.map(function (product) {
                return product.dataset.id;
              }); // const expressCheckoutLink = `${Shopify.routes.root}cart/${selectedProductIds.join(':1,')}:1?checkout[email]=${email}`;
              _context3.next = 8;
              return this.clearCart();
            case 8:
              _context3.next = 10;
              return this.addProductsToCart(selectedProductIds);
            case 10:
              _context3.next = 12;
              return this.updateCartInfo();
            case 12:
              goToCheckoutButton = document.getElementById('CheckOut');
              goToCheckoutButton.click();
              // window.location.href = expressCheckoutLink;
              _context3.next = 19;
              break;
            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](0);
              console.error('Error handling quiz submit:', _context3.t0);
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 16]]);
      }));
      function handleQuizSubmit() {
        return _handleQuizSubmit.apply(this, arguments);
      }
      return handleQuizSubmit;
    }()
  }, {
    key: "clearCart",
    value: function () {
      var _clearCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return fetch("".concat(Shopify.routes.root, "cart/clear.js"));
            case 3:
              response = _context4.sent;
              if (response.ok) {
                _context4.next = 6;
                break;
              }
              throw new Error("Failed to clear cart: ".concat(response.status));
            case 6:
              console.log('Cart cleared successfully');
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              console.error('Error clearing cart:', _context4.t0);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 9]]);
      }));
      function clearCart() {
        return _clearCart.apply(this, arguments);
      }
      return clearCart;
    }()
  }, {
    key: "updateCartInfo",
    value: function () {
      var _updateCartInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var formData, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              formData = {
                attributes: {
                  _Source: 'Quiz'
                }
              };
              _context5.prev = 1;
              _context5.next = 4;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              });
            case 4:
              response = _context5.sent;
              if (response.ok) {
                _context5.next = 7;
                break;
              }
              throw new Error(response.statusText);
            case 7:
              window.location.href = '/checkout';
              _context5.next = 13;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](1);
              // eslint-disable-next-line no-console
              console.error(_context5.t0);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 10]]);
      }));
      function updateCartInfo() {
        return _updateCartInfo.apply(this, arguments);
      }
      return updateCartInfo;
    }()
  }, {
    key: "addProductsToCart",
    value: function () {
      var _addProductsToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(productIds) {
        var formData, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              // Items should be in the format [{ id: 'productId', quantity: 1, propetries {} }]
              formData = {
                items: productIds.map(function (id) {
                  return {
                    id: id,
                    quantity: 1,
                    properties: {
                      '_Tilføjet fra': 'Quiz'
                    }
                  };
                })
              };
              _context6.next = 4;
              return fetch("".concat(Shopify.routes.root, "cart/add.js"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              });
            case 4:
              response = _context6.sent;
              if (response.ok) {
                _context6.next = 7;
                break;
              }
              throw new Error("Failed to add products to cart: ".concat(response.status));
            case 7:
              _context6.next = 12;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](0);
              console.error('Error adding products to cart:', _context6.t0);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 9]]);
      }));
      function addProductsToCart(_x2) {
        return _addProductsToCart.apply(this, arguments);
      }
      return addProductsToCart;
    }()
  }, {
    key: "updateCustomerTags",
    value: function () {
      var _updateCustomerTags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(email) {
        var token, selectedYear, selectedPriceRange, handles, selectedPriceRangeValuesArray, tags, encodedEmail, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return this.getJwtToken(window.shopUrl);
            case 3:
              token = _context7.sent;
              // Get the JWT token (or refresh if expired)
              // Create tags for the selected price range like quiz:price:100-200
              // create tags for the selected year like quiz:year:2020
              selectedYear = localStorage.getItem('selectedYear');
              selectedPriceRange = this.querySelector('range-slider');
              handles = Array.from(selectedPriceRange.querySelectorAll('.handle'));
              selectedPriceRangeValuesArray = handles.map(function (handle) {
                return Number(handle.dataset.value);
              });
              tags = ["quiz:year:".concat(selectedYear), "quiz:price:".concat(selectedPriceRangeValuesArray.join('-'))];
              encodedEmail = encodeURIComponent(email);
              _context7.next = 12;
              return fetch("https://customeractions-6x8e5.ondigitalocean.app/api/customers/".concat(encodedEmail, "/tags"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(token)
                },
                body: JSON.stringify({
                  tags: tags
                })
              });
            case 12:
              response = _context7.sent;
              if (response.ok) {
                _context7.next = 15;
                break;
              }
              throw new Error("Failed to update customer tags: ".concat(response.status));
            case 15:
              _context7.next = 20;
              break;
            case 17:
              _context7.prev = 17;
              _context7.t0 = _context7["catch"](0);
              console.error('Error updating customer tags:', _context7.t0);
            case 20:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 17]]);
      }));
      function updateCustomerTags(_x3) {
        return _updateCustomerTags.apply(this, arguments);
      }
      return updateCustomerTags;
    }()
  }, {
    key: "getJwtToken",
    value: function () {
      var _getJwtToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(shop) {
        var token;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              token = localStorage.getItem('jwtTokenBundle'); // If no token, or the token is expired, request a new one
              if (!(!token || this.isTokenExpired(token))) {
                _context8.next = 7;
                break;
              }
              console.log('Token expired or missing. Getting a new token...');
              _context8.next = 6;
              return this.refreshJwtToken(shop);
            case 6:
              token = _context8.sent;
            case 7:
              return _context8.abrupt("return", token);
            case 10:
              _context8.prev = 10;
              _context8.t0 = _context8["catch"](0);
              console.error('Failed to get JWT token', _context8.t0);
            case 13:
              return _context8.abrupt("return", null);
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 10]]);
      }));
      function getJwtToken(_x4) {
        return _getJwtToken.apply(this, arguments);
      }
      return getJwtToken;
    }()
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(token) {
      var decodedToken = this.decodeJwtToken(token);
      if (decodedToken && decodedToken.exp) {
        var expiry = decodedToken.exp * 1000; // Convert to milliseconds
        return Date.now() > expiry;
      }
      return false;
    }
    // Decode JWT token (you can use any JWT library here)
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "decodeJwtToken",
    value: function decodeJwtToken(token) {
      try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
        }).join(''));
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error('Failed to decode JWT token', e);
        return null;
      }
    }
    // Refresh the JWT token
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "refreshJwtToken",
    value: function () {
      var _refreshJwtToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(shop) {
        var response, data, jwtToken;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return fetch('https://customeractions-6x8e5.ondigitalocean.app/api/auth', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  shop: shop
                }) // Send shop identifier
              });
            case 2:
              response = _context9.sent;
              if (response.ok) {
                _context9.next = 5;
                break;
              }
              throw new Error('Failed to refresh token');
            case 5:
              _context9.next = 7;
              return response.json();
            case 7:
              data = _context9.sent;
              jwtToken = data.token;
              localStorage.setItem('jwtTokenBundle', jwtToken);
              return _context9.abrupt("return", jwtToken);
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function refreshJwtToken(_x5) {
        return _refreshJwtToken.apply(this, arguments);
      }
      return refreshJwtToken;
    }()
  }, {
    key: "handleRestart",
    value: function handleRestart() {
      this.currentQuestion = 0;
      this.updateButtonsState(this.nextButton, false, this.prevButton, true);
      this.updateProgressBar();
      this.updateQuestions();
      this.restartButton.classList.add('tw-hidden');
      this.nextButton.classList.remove('tw-hidden');
      this.prevButton.classList.remove('tw-hidden');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/RangeSlider/RangeSlider.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/RangeSlider/RangeSlider.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ RangeSlider)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RangeSlider = /*#__PURE__*/function (_HTMLElement) {
  function RangeSlider() {
    var _this;
    _classCallCheck(this, RangeSlider);
    _this = _callSuper(this, RangeSlider);
    // Initialize state
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "min", void 0);
    _defineProperty(_this, "max", void 0);
    _defineProperty(_this, "step", void 0);
    _defineProperty(_this, "unit", void 0);
    _defineProperty(_this, "dragging", void 0);
    _defineProperty(_this, "track", void 0);
    _defineProperty(_this, "trackFill", void 0);
    _defineProperty(_this, "handles", void 0);
    _defineProperty(_this, "valueStart", void 0);
    _defineProperty(_this, "valueEnd", void 0);
    _this.value = [0, 0];
    _this.step = 100;
    _this.unit = 'kr';
    _this.dragging = null;
    // Initialize DOM references
    _this.track = null;
    _this.trackFill = null;
    _this.handles = null;
    _this.valueStart = null;
    _this.valueEnd = null;
    // Bind methods
    _this.startDragging = _this.startDragging.bind(_this);
    _this.stopDragging = _this.stopDragging.bind(_this);
    _this.drag = _this.drag.bind(_this);
    return _this;
  }
  _inherits(RangeSlider, _HTMLElement);
  return _createClass(RangeSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Create DOM structure
      this.innerHTML = "\n      <div class=\"slider-container\">\n        <div class=\"track\">\n          <div class=\"track-fill\"></div>\n          <div class=\"handle\" data-handle=\"0\"></div>\n          <div class=\"handle\" data-handle=\"1\"></div>\n        </div>\n        <div class=\"values\">\n          <span class=\"value-start\"></span>\n          <span class=\"value-end\"></span>\n        </div>\n      </div>\n    ";
      // Get elements
      this.track = this.querySelector('.track');
      this.trackFill = this.querySelector('.track-fill');
      this.handles = this.querySelectorAll('.handle');
      this.valueStart = this.querySelector('.value-start');
      this.valueEnd = this.querySelector('.value-end');
      if (!this.track || !this.trackFill || !this.handles || !this.valueStart || !this.valueEnd) {
        throw new Error('Required elements not found');
      }
      // Initialize from attributes
      this.min = Number(this.getAttribute('min')) || 0;
      this.max = Number(this.getAttribute('max')) || 100;
      this.step = Number(this.getAttribute('step')) || 1;
      this.unit = this.getAttribute('unit') || 'kr';
      var initialValue = this.getAttribute('value');
      if (initialValue) {
        this.value = [Number(initialValue), this.max];
      } else {
        this.value = [this.min, this.max];
      }
      // Add event listeners
      this.handles.forEach(function (handle) {
        handle.addEventListener('mousedown', _this2.startDragging);
        handle.addEventListener('touchstart', _this2.startDragging, {
          passive: false
        });
      });
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('touchmove', this.drag, {
        passive: false
      });
      document.addEventListener('mouseup', this.stopDragging);
      document.addEventListener('touchend', this.stopDragging);
      // Initial render
      this.updateHandlePositions();
      this.updateTrackFill();
      this.updateValues();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('touchmove', this.drag);
      document.removeEventListener('mouseup', this.stopDragging);
      document.removeEventListener('touchend', this.stopDragging);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;
      switch (name) {
        case 'min':
          this.min = Number(newValue) || 0;
          break;
        case 'max':
          this.max = Number(newValue) || 100;
          break;
        case 'step':
          this.step = Number(newValue) || 1;
          break;
        case 'unit':
          this.unit = newValue;
          break;
        case 'value':
          this.value[0] = Number(newValue) || this.min;
          break;
      }
      if (this.isConnected) {
        this.innerHTML = ''; // Clear current content
        this.connectedCallback(); // Reinitialize component
      }
    }
  }, {
    key: "startDragging",
    value: function startDragging(event) {
      var target = event.composedPath ? event.composedPath()[0] : event.target;
      if (!target) return;
      event.preventDefault();
      this.dragging = Number(target.dataset.handle);
      target.style.transition = 'none';
    }
  }, {
    key: "stopDragging",
    value: function stopDragging() {
      if (this.dragging !== null && this.handles) {
        var handle = this.handles[this.dragging];
        if (handle) {
          handle.style.transition = '';
        }
        this.dragging = null;
      }
    }
  }, {
    key: "drag",
    value: function drag(event) {
      if (this.dragging === null || !this.track || !this.handles) return;
      event.preventDefault();
      var rect = this.track.getBoundingClientRect();
      var clientX = 'touches' in event ? event.touches[0].clientX : event.clientX;
      var position = (clientX - rect.left) / rect.width;
      position = Math.max(0, Math.min(1, position));
      // Snap to step
      var range = this.max - this.min;
      var valueInRange = position * range + this.min;
      var steppedValue = Math.round(valueInRange / this.step) * this.step;
      position = (steppedValue - this.min) / range;
      // Update value based on handle
      if (this.dragging === 0) {
        if (steppedValue < this.value[1]) {
          this.value[0] = steppedValue;
          this.handles[0].setAttribute('data-value', this.value[0].toString());
        }
      } else {
        if (steppedValue > this.value[0]) {
          this.value[1] = steppedValue;
          this.handles[1].setAttribute('data-value', this.value[1].toString());
        }
      }
      this.updateHandlePositions();
      this.updateTrackFill();
      this.updateValues();
      // Dispatch events
      this.dispatchEvent(new CustomEvent('change', {
        detail: {
          values: this.value
        },
        bubbles: true,
        composed: true
      }));
      this.dispatchEvent(new CustomEvent('range-slider-change', {
        detail: {
          values: this.value
        },
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "updateHandlePositions",
    value: function updateHandlePositions() {
      var _this3 = this;
      if (!this.handles) return;
      this.handles.forEach(function (handle, index) {
        var position = (_this3.value[index] - _this3.min) / (_this3.max - _this3.min) * 99;
        if (position === 0) {
          position = 1;
        }
        handle.style.left = "".concat(position, "%");
        handle.dataset.value = _this3.value[index].toString();
      });
    }
  }, {
    key: "updateTrackFill",
    value: function updateTrackFill() {
      if (!this.trackFill) return;
      var leftPos = (this.value[0] - this.min) / (this.max - this.min) * 99;
      var rightPos = (this.value[1] - this.min) / (this.max - this.min) * 99;
      this.trackFill.style.left = "".concat(leftPos, "%");
      this.trackFill.style.width = "".concat(rightPos - leftPos, "%");
    }
  }, {
    key: "updateValues",
    value: function updateValues() {
      if (!this.valueStart || !this.valueEnd) return;
      this.valueStart.textContent = "".concat(this.value[0], " ").concat(this.unit);
      this.valueEnd.textContent = "".concat(this.value[1], " ").concat(this.unit);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['min', 'max', 'step', 'value', 'unit'];
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/utils/CookieMethods.ts":
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   deleteCookie: () => (/* binding */ deleteCookie),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   setCookie: () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/app": 0,
/******/ 			"shopify-theme/assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkvinvinedk"] = self["webpackChunkvinvinedk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/app"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/app"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;